import { stackStyles } from './stack.styles';
import { MediaSizeMixin } from '../../utilities/media-size-observer';
import { attr, FASTElement, html } from '@microsoft/fast-element';
import { NatGenDesignSystem } from '../../natgen-design-system';

export type StackAppearance = 'compact' | 'default';
// TODO: Make a generic one to be shared between similar components with directions?
export type StackDirection = 'row' | 'row-reverse' | 'column' | 'column-reverse';
export type StackAlignment = 'start' | 'center' | 'end' | 'stretch';

/**
 * @element natgen-stack
 */
export class NatGenStack extends MediaSizeMixin(FASTElement) {
    @attr appearance: StackAppearance = 'default';
    @attr direction: StackDirection = 'column';
    @attr alignment: StackAlignment = 'start';
    @attr wrap: boolean = false;
}

export const natGenStackDefinition = NatGenStack.compose({
    name: `${NatGenDesignSystem.prefix}-stack`,
    template: html`<slot></slot>`,
    styles: stackStyles
});
